import { useEffect } from 'react';

/** @typedef {Window & typeof globalThis & { ttq?: any, TiktokAnalyticsObject?: string }} TikTokWindow */

const TikTokPixel = () => {
  useEffect(() => {
    /** @type {TikTokWindow} */
    const typedWindow = window;
    const tiktokPixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
    const isProduction = process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'production';
    if (!isProduction) {
      return;
    }
    if (!tiktokPixelId) {
      return;
    }

    if (typedWindow.ttq && typedWindow.ttq.__loaded) {
      return;
    }

    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      const ttq = (w[t] = w[t] || []);

      ttq.methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
        'holdConsent',
        'revokeConsent',
        'grantConsent',
      ];
      ttq.setAndDefer = function (target, method) {
        target[method] = function () {
          target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };

      for (let i = 0; i < ttq.methods.length; i += 1) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
      }

      ttq.instance = function (id) {
        const instanceQueue = ttq._i[id] || [];
        for (let i = 0; i < ttq.methods.length; i += 1) {
          ttq.setAndDefer(instanceQueue, ttq.methods[i]);
        }
        return instanceQueue;
      };

      ttq.load = function (id, options) {
        const src = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {};
        ttq._i[id] = [];
        ttq._i[id]._u = src;
        ttq._t = ttq._t || {};
        ttq._t[id] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[id] = options || {};

        const script = d.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `${src}?sdkid=${id}&lib=${t}`;
        const firstScript = d.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      };

      ttq.load(tiktokPixelId);
      ttq.page();
      ttq.__loaded = true;
    })(typedWindow, document, 'ttq');
  }, []);

  return null;
};

export default TikTokPixel;
